import React from 'react';
import { Alert, AlertTitle, Box, Button } from '@mui/material';
import { Refresh } from '@mui/icons-material';

interface ListLoadErrorAlertProps {
  /** Short noun for the list, e.g. "documents", "tasks" */
  resourceLabel: string;
  message?: string;
  onRetry?: () => void;
}

/**
 * Soft load failure banner for list pages.
 * Keep page chrome (headers, Add buttons) mounted — do not replace the whole page.
 */
const ListLoadErrorAlert: React.FC<ListLoadErrorAlertProps> = ({
  resourceLabel,
  message,
  onRetry,
}) => (
  <Alert
    severity="warning"
    sx={{ mb: 2 }}
    action={
      onRetry ? (
        <Button color="inherit" size="small" startIcon={<Refresh />} onClick={onRetry}>
          Retry
        </Button>
      ) : undefined
    }
  >
    <AlertTitle>Couldn’t refresh {resourceLabel}</AlertTitle>
    {message
      || `The list couldn’t be loaded right now. You can still add new ${resourceLabel} below.`}
  </Alert>
);

export default ListLoadErrorAlert;
